module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("chapter one")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("morning minis")])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Small A.M. Meals with Huge Appeal")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraCenter11",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/23.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Never skip breakfast. Everyone who tells you that—from your mom to your doctor—is 100 percent right. There’s no reason to get all preachy and tell you WHY breakfast is so important…it just is. But huge breakfasts can bog you down and make you feel like a lazy slug. The light recipes in this chapter are creative, easy, fun, and EXTREMELY delicious. Wake up and eat, people!")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("fab-five banana pancake minis")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (5 mini pancakes): 185 calories, 1g fat, 343mg sodium, 37g carbs, 5g fiber, 7.5g sugars, 9.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Yep, there are FIVE of these banana-licious babies in this single-serving recipe. And they have just the right amount of banana flavor. These are great with sugar-free pancake syrup or just a squirt of Fat Free Reddi-wip.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup whole-wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup mashed ripe banana (about half a banana’s worth)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("3 tablespoons fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon light vanilla soymilk")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("8")]), _vm._v(" teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 no-calorie sweetener packet")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash salt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a small bowl, combine all dry ingredients (flour, baking powder, sweetener, salt, and cinnamon) until mixed well.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a separate bowl, combine mashed banana with all wet ingredients (egg substitute, soymilk, and vanilla extract) until mixed thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Combine dry and wet ingredients, and stir thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Bring a large pan sprayed with nonstick spray to medium heat. Pour batter in the pan to form five mini pancakes. Once pancakes begin to look solid, after about 1 minute, gently flip.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Cook for an additional minute, or until both sides are lightly browned and insides are cooked through. Then plate ’em up and enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("complete & utter oatmeal insanity")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire recipe): 179 calories, 3.5g fat, 367mg sodium, 40g carbs, 11g fiber, 3g sugars, 7g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Yes, the idea of tossing SO many things (including whipped cream) into oatmeal may in fact be a little insane. But we wouldn’t have it any other way! This is one of my very favorite decadent breakfasts.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 packet plain instant oatmeal")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup Fiber One bran cereal (original)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup light vanilla soymilk")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons canned pure pumpkin")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons Fat Free Reddi-wip")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon sugar-free pancake syrup")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ teaspoon pumpkin pie spice")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("5 sprays I Can’t Believe It’s Not Butter! Spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 no-calorie sweetener packet")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Place all ingredients except for Reddi-wip in a medium microwave-safe bowl. Add ¼ cup water and stir.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Microwave for 45 seconds, then mix well.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Microwave for an additional 30 to 40 seconds. Allow oatmeal to thicken before removing from the microwave.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add Reddi-wip and stir well. Then enjoy the best bowl of oatmeal you’ve EVER tasted!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The city of Lafayette, Colorado, REALLY loves oatmeal! Each January the city hosts an oatmeal festival, featuring a bake-off, health screenings, a big hearty ’n healthy oatmeal breakfast, and (sometimes) an oatmeal mini spa!")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("spinach, tomato, feta ’n egg wrap attack")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire wrap): 168 calories, 5.5g fat, 694mg sodium, 24g carbs, 15g fiber, 2g sugars, 20g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This was conjured up when the folks at Starbucks threatened to pull the plug on their version of this popular breakfast wrap. They decided not to (yay!), but that was after our version was already whipped up (double yay!).")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 large La Tortilla Factory Smart & Delicious Low Carb/High Fiber tortilla")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ cup chopped fresh spinach")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1½ tablespoons crumbled reduced-fat feta cheese with basil and tomato flavoring (plain is fine, too)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon canned fire-roasted diced tomatoes with garlic")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 pieces sun-dried tomato packed in oil and spices, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spray a small pan with nonstick spray and bring to medium heat. Add egg substitute and cook to form an egg patty, flipping and folding until firm, about 1 to 2 minutes on each side. Remove egg patty and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Remove pan from heat, re-spray, and then return to medium heat. Add chopped spinach and both types of tomatoes. Cook for about 1 minute, stirring occasionally, until spinach has wilted.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add cheese to the pan and cook for an additional 30 seconds, until softened. Remove from heat and allow to cool slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Meanwhile, heat tortilla in the microwave until slightly warm. Place veggie-cheese mixture in the center of the tortilla. Place egg patty on top and wrap the tortilla up envelope style, folding the sides in first and then rolling it up from the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Place wrap in the toaster oven, seam side down, and bake for 1 to 2 minutes, until thoroughly heated. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxHeadA",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Fast Fact:")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("The original Starbucks wrap has 240 calories, 10 grams fat, and 7 grams fiber. Not bad, especially for the ’Bucks! However, as you can see, there’s always room for improvement.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("slammin’ smoked salmon ’n bacon b-fast sandwich")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire sandwich): 194 calories, 3g fat, 936mg sodium, 25g carbs, 6g fiber, 2g sugars, 19.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("OMG! This little sandwich is CRAZY-decadent. The combo of smoked salmon, turkey bacon, and red onion mixed with cream cheese is so good, you may actually cry when you taste it. Not exaggerating here, people!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 light English muffin")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 ounce smoked salmon, roughly chopped")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 slice extra-lean turkey bacon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons fat-free cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon chopped red onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon chopped cucumber")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 slice tomato")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Cook bacon slice according to package directions, either in the microwave or in a pan sprayed with nonstick spray. Once cool enough to handle, chop the bacon into small pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a small dish, combine cream cheese with smoked salmon, chopped bacon, onion, and cucumber until mixed well.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Split muffin into halves, and heat or toast halves.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spread cream cheese mixture over half of the English muffin. Top with the tomato slice.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Finish it all off with the other muffin half, pressing down firmly. Your sandwich is now ready for consumption!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("tutti frutti biscuits")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (1 biscuit): 132 calories, 2.25g fat, 240mg sodium, 26g carbs, 2g fiber, 7.5g sugars, 3.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("These biscuits are INCREDIBLE. They’re not overly sweet, and they have a bit of a scone-like feel to them but with the softer texture of a biscuit.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("2")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup canned bite-sized fruit cocktail packed in juice, drained well")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("2")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup regular oats (not instant)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup Bisquick Heart Smart baking mix")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup light vanilla soymilk")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons sugar-free strawberry preserves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon Splenda No Calorie Sweetener (granulated)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon brown sugar (not packed)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 teaspoons light whipped butter or light buttery")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("spread, melted and cooled")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¾ teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Preheat oven to 425 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a small bowl, mix preserves with a fork until a syrup-like consistency is reached. Pat fruit cocktail as dry as possible, eliminating as much moisture as you can. Toss fruit cocktail in the preserves until thoroughly coated. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a medium bowl, combine oats, baking mix, Splenda, brown sugar, baking powder, and salt. Stir in melted butter and mix well.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/28.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add soymilk and stir until mixed thoroughly. Then fold fruit mixture into the batter.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("On a baking sheet sprayed with nonstick spray, divide batter into 4 evenly spaced mounds. Bake for about 12 minutes, or until tops are firm and edges begin to brown. Let cool slightly, and then enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The lyrics to Little Richard’s hit song are “Tutti Frutti, all rooty.” “All rooty” was hipster slang at the time for “all right.” No, the song isn’t about someone named Rudy…")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter11",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/29.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha06"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("creamy hot apple b-fast with brown sugar crunch")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire recipe): 189 calories, 3g fat, 385mg sodium, 40g carbs, 3g fiber, 19g sugars, 2g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Hot breakfast in a bowl is awesome, but so many people complain that they’re bored with it. Be a little kooky! This recipe calls for a granola bar, apples, and a few other key ingredients. It’s PERFECT for a chilly fall or winter morning.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 cup peeled apple chunks (any sweet, not tart, variety)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 Nature Valley Maple Brown Sugar Crunchy Granola Bar (half a 2-bar package)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1½ teaspoons sugar-free fat-free vanilla instant pudding mix")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 no-calorie sweetener packets")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1½ teaspoons cornstarch")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a medium-large microwave-safe bowl, place pudding mix, sweetener, cornstarch, cinnamon, and salt. Add "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup cold water and stir until blended.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add apple chunks to the bowl and toss them in the liquid mixture. Cover bowl and microwave for 2½ minutes. Allow mixture to thicken and cool for a few minutes before removing from the microwave.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Meanwhile, place the granola bar in a sealable plastic bag. Place on a flat surface, and use a rolling pin or a can to crush the bar through the bag until you have small crumbly pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Once bowl containing apple mixture is cool enough to handle, stir in granola pieces. Devour immediately!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The first McIntosh apples were discovered on a mutated apple tree in Canada. Luckily, John McIntosh was an adventurous eater. Mmmmm, what delicious mutant apples you have!")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha07"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("choco-monkey oatmeal")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire recipe): 185 calories, 2g fat, 137mg sodium, 37g carbs, 5g fiber, 11g sugars, 6.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This recipe is NOT recommended for monkeys, although they would probably love it (they’re not stupid!). Chocolate-banana oatmeal is a yummy treat for all humans (kids especially love this stuff).")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup regular oats (not instant)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("One 25-calorie packet diet hot cocoa mix")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("One-half medium banana, mashed")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("8")]), _vm._v(" teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 no-calorie sweetener packet")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Pour cocoa mix into a glass with cinnamon, sweetener, and salt. Add ¼ cup hot water and stir thoroughly. Once cocoa mix has dissolved, add ¼ cup cold water and stir.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a large microwave-safe cereal bowl, combine cocoa mixture with mashed banana and oats until mixed well. Microwave for 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Give it a stir, and then allow oatmeal to cool and thicken. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ever wonder if monkeys TRULY like bananas or if it’s just a myth? Well, it’s absolutely true. Thing is, monkeys like pretty much all fruit, and it just so happens that bananas and monkeys are native to similar regions. So be a good monkey and eat your fruit!")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha08"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("grab ’n go breakfast cookies")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (1 cookie): 154 calories, 1.5g fat, 166mg sodium, 32.5g carbs, 5g fiber, 10.5g sugars, 5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("These breakfast cookies are such a hit, we’re constantly whipping up batches to keep around the HG HQ for snacking. And if you make ’em in the P.M. you’ll have super-quick b-fasts for the next few A.M.s! They’re slightly addictive, though, so watch out!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ cup regular oats (not instant)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("6 tablespoons whole-wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup Fiber One bran cereal (original)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup Splenda No Calorie Sweetener (granulated)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup Gerber peaches (or another brand of pureed peaches found in the baby food aisle)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup canned pure pumpkin")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon golden raisins")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon Ocean Spray Craisins (original)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons brown sugar (not packed)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 teaspoons Coffee-mate Sugar Free French Vanilla powdered creamer")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("8")]), _vm._v(" teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Preheat oven to 375 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Chop raisins and Craisins into small pieces. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a food processor or blender, grind Fiber One to a breadcrumb-like consistency.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a large bowl, combine oats, flour, Fiber One crumbs, Splenda, brown sugar, baking powder, cinnamon, and salt until mixed well.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a medium bowl, dissolve powdered creamer in 2 tablespoons hot water. Add all other wet ingredients (pureed peaches, pumpkin, and egg substitute) and stir until mixed well.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add liquid mixture to dry ingredients and stir until completely blended. Slowly sprinkle chopped raisins and Craisins into the batter, making sure they don’t all stick together.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spray a large baking sheet with nonstick spray and spoon batter into 4 evenly spaced circles. Spread batter out a bit with the back of a spoon.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Bake in the oven for 12 to 14 minutes, until tops of treats are just slightly crispy. Allow to cool slightly on the sheet. Grab ’n go!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("For Weight Watchers "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("POINTS"), _c('sup', [_vm._v("®")])])]), _vm._v(" values and photos of all the recipes in this book, check out "), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://hungry-girl.com/book",
      "target": "_blank"
    }
  }, [_vm._v("hungry-girl.com/book")])]), _vm._v(".")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/33.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha09"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("eggless stuffed breakfast burrito")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire burrito): 199 calories, 6g fat, 892mg sodium, 28g carbs, 15g fiber, 5.5g sugars, 21g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Who says breakfast burritos NEED some sort of egg? Is there a rule? This burrito has cheese, veggies, and bacon—and it is completely egg-free. Weeeeee!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 large La Tortilla Factory Smart  &  Delicious Low Carb/High Fiber tortilla")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 slice extra-lean turkey bacon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 cups fresh spinach leaves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup diced mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup diced plum tomatoes (preferably Roma)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup diced green bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons diced onion")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 wedge The Laughing Cow Light Original Swiss cheese")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons shredded fat-free cheddar cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Cut bacon into small, bite-sized pieces. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spray a small pan with nonstick spray and bring to medium-high heat. Add bacon pieces, mushrooms, pepper, and onion to the pan. Stirring occasionally, cook until bacon begins to crisp, 4 to 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add spinach leaves and cook and stir until the leaves have wilted. Add shredded cheese and stir until just melted. Remove pan from heat and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Warm tortilla in the microwave for about 10 seconds. Lay tortilla flat and spread cheese wedge on top of it. Evenly layer spinach mixture over the cheese–topped tortilla. Place diced tomatoes on top of spinach mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Fold in the sides of the tortilla, and then carefully roll tortilla up from the bottom to the top. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha10"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("cinnamon-vanilla french toast nuggets")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (8 nuggets): 151 calories, 2.25g fat, 299mg sodium, 24g carbs, 1.5g fiber, 3.5g sugars, 8.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Yes, we made French toast out of hot dog buns. Don’t judge us. These are actually AWESOME and fluffy. And you get to eat EIGHT nuggets. That rocks!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 hot dog buns")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 teaspoon Coffee-mate Sugar Free French Vanilla powdered creamer")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 dashes cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Optional topping: sugar-free pancake syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Split each bun in half and cut each of those halves into 4 pieces, leaving you with 16 chunks of bread.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a small bowl, dissolve powdered creamer in 1 tablespoon warm water. Add egg substitute and 1 dash cinnamon, stirring until mixed well.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Bring a large pan sprayed with nonstick spray to medium-high heat. Dip or soak bread pieces in egg mixture, covering them completely. Place egg-dipped bread pieces in the pan and cook for 3 to 5 minutes, flipping occasionally to cook all sides.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Remove from heat and plate your nuggets. Sprinkle with another dash cinnamon. If you like, top with some sugar-free pancake syrup.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Most of us know it as “French toast,” but in France they actually call the dish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“pain perdu,”")]), _vm._v(" which means “lost bread.” The theory is that even if you forget about your bread and it gets a little stale, you can soften it up by dunking it in egg. Genius!")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("cheesy-good breakfast tartlets")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (2 tartlets): 111 calories, 2g fat, 553mg sodium, 10.5g carbs, 0.5g fiber, 1.5g sugars, 11g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("These are overflowing with cheesed-up egg, turkey bacon, and more. They’re a little fancy, so feel free to serve them to brunch guests. No one (except you) will know they’re low in calories and fat. NO ONE.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 cup fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("8 small square wonton wrappers")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 slices extra-lean turkey bacon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 cup chopped mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup chopped scallions")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 wedge The Laughing Cow Light Original Swiss cheese, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons fat-free cream cheese, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("48 sprays I Can’t Believe It’s Not Butter! Spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ teaspoon sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Optional: additional salt, black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Preheat oven to 350 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spray 8 cups of a 12-cup muffin pan with nonstick spray and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("On a clean, dry surface, spread out wonton wrappers. Spray each one with 3 sprays of butter, and use your fingers to spread butter evenly over each wrapper. Gently flip wrappers and repeat on the other sides.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Carefully transfer wonton wrappers to the muffin pan, placing each wrapper in a muffin cup and pressing it in to form the cup shape. Bake in the oven for 10 minutes, until wonton cups are firm and brown.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Prepare bacon slices according to package directions, either in the microwave or in a pan sprayed with nonstick spray. Once cool enough to handle, chop the bacon into small pieces and set aside.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a small bowl, combine egg substitute and salt and whisk until blended. Stir in the scallions. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a small microwave-safe dish, combine cheese wedge and cream cheese. Stir until blended. Warm in the microwave for 15 seconds, and then stir again. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Bring a medium pan sprayed with nonstick spray to medium heat on the stove. Add mushrooms, and cook and stir for 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add egg mixture to the pan. Scramble as you would ordinary eggs. Once solid bits begin to form, slowly fold in cheese mixture, one spoonful at a time. Continue to cook and stir until egg mixture is solid.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Remove from heat and mix chopped bacon into the pan immediately. Evenly distribute egg mixture among the baked wonton cups. Serve warm. If you like, season to taste with a little salt and/or black pepper. Yum!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("For Weight Watchers "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("POINTS"), _c('sup', [_vm._v("®")])])]), _vm._v(" values and photos of all the recipes in this book, check out "), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://hungry-girl.com/book",
      "target": "_blank"
    }
  }, [_vm._v("hungry-girl.com/book")])]), _vm._v(".")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha12"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("creamy crunchy freeze-dried frenzy")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire recipe): 165 calories, 0.5g fat, 180mg sodium, 40g carbs, 7g fiber, 12g sugars, 11g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Okay, this so-called frenzy is actually a parfait. But the word “frenzy” makes it seem a little more exciting, no? Freeze-dried fruit and Fiber One cereal make this breakfast super-crunchy.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("6 ounces fat-free vanilla yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup freeze-dried fruit (any variety)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup Fiber One bran cereal (original)")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Place half the yogurt in a bowl or parfait glass.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Top with half the fruit followed by half the cereal. Repeat.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Now devour!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/38.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Tip!")]), _vm._v(" This recipe can be made with any type of freeze-dried fruit, so pick your favorite. We like to grab Gerber’s Mini Fruits blend of banana and strawberries from the baby food aisle. And even though the package warns, “This product should only be fed to a seated and supervised child,” we eat ’em anyway…and we’re not always seated and supervised.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha13"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("berries & cream oatmeal pudding")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire recipe): 190 calories, 2.5g fat, 501mg sodium, 35.5g carbs, 5g fiber, 7g sugars, 5.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Gotta be honest…This isn’t always the prettiest breakfast on the table, but it tastes FANTASTIC. So ignore the scary array of colors that emerge from your bowl and dig in. Mmmmmmmm!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup regular oats (not instant)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ cup frozen unsweetened mixed berries")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup light vanilla soymilk")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon sugar-free fat-free vanilla instant pudding mix")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 teaspoon Coffee-mate Sugar Free French Vanilla powdered creamer")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 no-calorie sweetener packet")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a medium microwave-safe bowl, combine powdered creamer with ¼ cup warm water. Stir until dissolved.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add soymilk and pudding mix, and stir until mixture is thoroughly blended. Add all of the other ingredients to the bowl and stir.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Microwave for 3 minutes. Allow to cool and thicken. Dig in!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("For Weight Watchers "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("POINTS"), _c('sup', [_vm._v("®")])])]), _vm._v(" values and photos of all the recipes in this book, check out "), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://hungry-girl.com/book",
      "target": "_blank"
    }
  }, [_vm._v("hungry-girl.com/book")])]), _vm._v(".")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha14"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("big fat blueberry muffins")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (1 muffin): 137 calories, 2.25g fat, 269mg sodium, 26.5g carbs, 3g fiber, 7.5g sugars, 4g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("These muffins are phenomenal. Plain and simple. And while they ARE big and fat, they’re NOT fattening.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 cup whole-wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 cup fresh blueberries")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ cup light vanilla soymilk")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup sugar-free pancake syrup")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup Splenda No Calorie Sweetener (granulated)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("3 tablespoons brown sugar (not packed)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons light whipped butter or light buttery spread, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons no-sugar-added applesauce (get Mott’s Blueberry Delight if you can find it!)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1½ teaspoons baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Preheat oven to 400 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a medium mixing bowl, combine flour, Splenda, brown sugar, baking powder, and salt, stirring until mixed well.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a large mixing bowl, combine soymilk, syrup, egg substitute, butter, applesauce, and vanilla extract. Using an electric mixer or a whisk, mix until thoroughly blended. Do not worry if butter bits do not break up completely.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add dry ingredients in the first mixing bowl to wet ingredients in the large mixing bowl and mix until completely blended. Then fold in blueberries.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Line a 6-cup muffin pan (or half a 12-cup pan) with baking liners and/or spray with nonstick spray. Evenly distribute batter among the 6 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Bake in the oven for about 22 minutes, until a toothpick inserted into the center of a muffin comes out clean. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 6 SERVINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SHOCKER ALERT! Besides berries, a Starbucks blueberry muffin is stuffed with around 500 calories and 19 grams fat. Ahhhhhhh!")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/41.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha15"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("easy caprese breakfast pizzas")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire recipe): 185 calories, 5g fat, 430mg sodium, 23.5g carbs, 6g fiber, 1.5g sugars, 14g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This is HG’s latest way to have pizza for breakfast. Fresh basil is soooo good!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 light English muffin")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 thick slices from a large firm plum tomato (we recommend Roma)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("6 fresh basil leaves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 piece light mozzarella string cheese, pulled into strips")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 teaspoon light whipped butter or light buttery spread")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ teaspoon crushed garlic")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Optional: salt, black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Preheat oven to 375 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a small dish, combine butter and garlic. Mix well and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Bring a pan sprayed with nonstick spray to medium-high heat on the stove. Cook tomato slices for 1 to 2 minutes on each side, until lightly blackened.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Split English muffin into halves. Spread garlic-butter mixture evenly over both halves. Top each half evenly with mozzarella cheese strips.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Place three basil leaves on top of each cheese-topped muffin half, followed by tomato slices.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/42.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Place halves on a baking sheet sprayed lightly with nonstick spray. Bake in the oven until the cheese has melted and muffin halves are toasty, about 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Finish off with a dash of salt and pepper on top of each tomato, if you like. Then devour!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxHeadA",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Fast Fact:")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Caprese means “in the style of Capri,” an island off the coast of Italy (about halfway down the west side of the boot). The colors in the traditional salad of tomato, basil, and mozzarella are a tribute to the Italian flag. A DELICIOUS tribute.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("For Weight Watchers "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("POINTS"), _c('sup', [_vm._v("®")])])]), _vm._v(" values and photos of all the recipes in this book, check out "), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://hungry-girl.com/book",
      "target": "_blank"
    }
  }, [_vm._v("hungry-girl.com/book")])]), _vm._v(".")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/43.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha16"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("oat")]), _vm._v("-rageous chocolate chip pancake minis")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (5 mini pancakes): 179 calories, 3.25g fat, 341mg sodium, 28g carbs, 3.5g fiber, 5g sugars, 9.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("These chocolate chip pancakes have fewer than 40 calories each. And even though they’re “mini,” they pack in a tremendous amount of chocolate flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("3 tablespoons regular oats (not instant)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("3 tablespoons fat-free liquid egg substitute")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons whole-wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon light vanilla soymilk")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ tablespoon mini semi-sweet chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("8")]), _vm._v(" teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 no-calorie sweetener packet")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash salt")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Place all ingredients in a small bowl, except for chocolate chips. Add 1 tablespoon water and stir until thoroughly mixed. Fold in chocolate chips.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Bring a large pan sprayed with nonstick spray to medium heat. Pour batter in the pan to form 5 mini pancakes. Once pancakes begin to look solid, after about 1 minute, gently flip.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Cook for an additional minute, or until both sides are lightly browned and insides are cooked through. Plate ’em and commence chewing!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("How’s this for inventive? Ruth Graves Wakefield of the Toll House Inn decided she wanted to put pieces of chocolate in her cookies, and that’s just what she did. She chopped up a Nestlé chocolate bar, and mixed in the bits. The result was so good that she told Nestlé, “Hey! Why don’t you make little bits of chocolate so I can put them in my cookies?” (Okay, maybe those weren’t her exact words, but you get the picture.)")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha17"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("piña colada parfait surprise")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire parfait): 175 calories, 0.5g fat, 129mg sodium, 42g carbs, 5g fiber, 28g sugars, 8g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This tropical morning treat will make you feel like you’re on vacation. And (SURPRISE!), it’s got bananas in it, too!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("6 ounces fat-free vanilla yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup canned pineapple tidbits packed in juice, drained")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup chopped banana")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons Fiber One bran cereal (original)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ teaspoon coconut extract")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Mix coconut extract into yogurt. Place about one-third of the yogurt mixture in the bottom of a parfait glass, or any small glass.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Top with half of the pineapple tidbits and half of the chopped banana.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Sprinkle half of the cereal over the fruit layer, and then spoon another third of the yogurt on top.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Add remaining pineapple and banana, and then add a final layer of yogurt.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Finish it all off with the rest of the cereal. Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The earliest known reference to a piña colada appeared in an article in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Travel")]), _vm._v(" magazine in 1922. One key ingredient wasn’t originally there")]), _vm._v("—"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("the coconut! “Piña colada” translates literally to “strained pineapple.” Some creative mixologist threw the coconut in much later. Very interesting…")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha18"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("sweet cinna-muffin")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire recipe): 126 calories, 3.25g fat, 268mg sodium, 22g carbs, 6g fiber, <0.5g sugars, 6g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This is a PERFECT little breakfast treat or anytime snack.")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("It’s buttery, sweet, and cinnamony. Yum!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 light English muffin")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 teaspoon light whipped butter or light buttery spread")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("10 sprays I Can’t Believe It’s Not Butter! Spray")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¾ teaspoon Splenda No Calorie Sweetener (granulated)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ teaspoon cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Split English muffin in half, and then spread each half evenly with butter spread.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a small dish, combine Splenda and cinnamon until mixed well. Sprinkle Splenda-cinnamon mixture over muffin halves.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spray each muffin half with 5 sprays of butter spray. Heat in the microwave (for a soft Cinna-Muffin) or in the toaster oven (for a crunchy Cinna-Muffin). Consume immediately. Weeeeee!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chew on This")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cinnamon is one of the oldest known spices. Because it was sought by early explorers, some people say that cinnamon contributed to the discovery of America. A stretch? Perhaps.")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha19"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("peachy maple–caramel crunch parfait")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire parfait): 174 calories, 0.5g fat, 212mg sodium, 37.5g carbs, 1.5g fiber, 26.5g sugars, 8.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Here’s another breakfast parfait recipe for you. This one combines the flavors of peach, caramel, and maple. Hence the name.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("6 ounces fat-free vanilla yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ cup chopped peaches")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("4 caramel soy crisps or mini rice cakes, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("2 tablespoons sugar-free pancake syrup")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Stir pancake syrup into yogurt and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Place a third of the peaches in the bottom of a parfait glass, or any small glass. Add half of the yogurt.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Top with another third of the peaches. Cover with half of the caramel crunchies.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spoon the rest of the yogurt on top, and cover with remaining fruit and crunchies. Sprinkle with cinnamon and enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("For Weight Watchers "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("POINTS"), _c('sup', [_vm._v("®")])])]), _vm._v(" values and photos of all the recipes in this book, check out "), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://hungry-girl.com/book",
      "target": "_blank"
    }
  }, [_vm._v("hungry-girl.com/book")])]), _vm._v(".")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha20"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("fro-yo’ed up oatmeal sundae")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (entire sundae): 198 calories, 4.25g fat, 219mg sodium, 38g carbs, 4g fiber, 11.5g sugars, 5.5g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("We like to be creative when it comes to breakfast, and this recipe is particularly fun. We put together a tasty bowl of fruity oatmeal and then snazzed it up with some frozen yogurt. Fro-yo for breakfast. Yee-ha!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup quick-cooking oatmeal")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup low-fat vanilla frozen yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup fresh blueberries")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup sliced fresh strawberries")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon strawberry (or any fruit flavor) sugar-free preserves")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ tablespoon All Natural Almond Accents in Original Oven Roasted or Honey Roasted")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 no-calorie sweetener packet")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("8")]), _vm._v(" teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("Dash salt")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Heads Up! Irish oatmeal is soooo good in this recipe! It’s heartier and more filling than regular oatmeal.")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In a microwave-safe bowl, combine oatmeal with ½ cup water. Microwave for 1 to 2 minutes, until desired consistency is reached.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Once bowl of oatmeal is cool enough to handle, mix in preserves, sweetener, cinnamon, and salt. Top with fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Place frozen yogurt on top of fruit layer, and then sprinkle with almonds.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/48.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Serve immediately—the frozen yogurt will melt, but it’s delicious as it melts into the oatmeal!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 1 SERVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxHeadA",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Fast Fact:")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("In the classic holiday movie "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frosty the Snowman")]), _vm._v(", one of the children suggests that they name their snowman Oatmeal. Sounds pretty appropriate now, considering this chilly oatmeal breakfast…")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newPage"
  }, [_c('br'), _c('br')]), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/k1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "cha21"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("gooey cinnamon rolls with cream cheese icing")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("PER SERVING (1 iced roll): 126 calories, 5g fat, 308mg sodium, 18.5g carbs, <0.5g fiber, 6.5g sugars, 3g protein")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Honestly, this is one of those recipes that’s so good, it’ll either make you laugh hysterically or cry uncontrollably. Emotion will ooze from you when you bite into one of these. Try it and see. You’ll never think about eating a Cinnabon again.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractHead",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("For Dough")])])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 package Pillsbury Reduced Fat Crescent Rolls refrigerated dough")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("16 sprays I Can’t Believe It’s Not Butter! Spray")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractHead",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("For Filling")])])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup dark brown sugar (not packed)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup Splenda No Calorie Sweetener (granulated)")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("½ tablespoon light whipped butter or light buttery spread, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1½ teaspoons cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("8")]), _vm._v(" teaspoon salt")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractHead",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("For Icing")])])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("¼ cup Cool Whip Free, thawed")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("3 tablespoons fat-free cream cheese, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "10%"
    }
  }, [_vm._v("1 tablespoon Splenda No Calorie Sweetener (granulated)")])]), _vm._v(" "), _c('div', {
    staticClass: "box2"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextCenter",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HG Heads Up! These cinnamon rolls double as breakfast AND dessert!")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/arr.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Directions")])]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Preheat oven to 375 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("To make filling, combine all ingredients in a medium bowl, stirring well to make sure the butter gets mixed in evenly. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("To make icing, combine all ingredients in a small bowl and mix until smooth and blended. Place in the fridge to chill and set.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Prepare a dry surface by sprinkling it with a small amount of flour to prevent sticking. Remove dough from package and knead into a ball.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Using a rolling pin dusted lightly with flour, very firmly roll out dough into a thin sheet about 8 inches by 12 inches. Spray the dough’s surface evenly with butter.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spread filling out evenly over dough, leaving a ½-inch border around the edges.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Starting with a long side of the dough, roll it up tightly, forming a log. Once dough is completely rolled up, pinch the long seam to seal.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Turn the log over so that the seam is facing down. Using a very sharp knife, cut log into 8 even pieces, being careful not to squish dough.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Spray a baking pan with nonstick spray and arrange pieces of dough in the pan with swirl sides facing up. Use your hands to firmly press down on the tops of the pieces. Pinch the side seams to seal, if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Cover pan with aluminum foil. Bake in the oven for 8 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Remove foil and return pan to oven. Bake for an additional 5 minutes, or until cinnamon rolls have risen and are slightly browned on top.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Evenly distribute icing over cinnamon rolls and then enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 8 SERVINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/51.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c0a01d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312556174_ch01.vue
// module id = 84
// module chunks = 0